import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import "../../common/helpers/enumHelper";
import "../../../node_modules/select2/dist/js/select2.js";
import * as ps from "perfect-scrollbar"
import { MenuItem } from "../../objects/components/menuItem";
import { StorageManager } from "../../common/managers/storageManager";
import { NavigationStart, GuardsCheckEnd, Router, NavigationEnd } from "@angular/router";
import { NavbarComponent } from "../navbar/navbar.component";
import { User } from "../../objects/users/user";
import { Group } from "../../objects/groups/group";
import { ScreenHelper } from "../../common/helpers/screenHelper";
import { CustomerModalComponent } from '../Managment/customerManagement/modal/customerModal.component';
import { ModalDirective } from 'ngx-bootstrap';
declare var $:any;

@Component({
    selector: 'layout',
    templateUrl: './layout.component.html',
    styleUrls: ['../../../theme/css/select.css',
        '../../../node_modules/select2/dist/css/select2.css',
        '../../../node_modules/@swimlane/ngx-datatable/release/index.css',
        '../../../node_modules/@swimlane/ngx-datatable/release/assets/icons.css',
        '../../../node_modules/@swimlane/ngx-datatable/release/themes/material.css',
        '../../../node_modules/@qontu/ngx-inline-editor/themes/bootstrap.css',
        '../../../theme/css/datatable.css'],
    moduleId: module.id.toString(),
    encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
    public menuItems: Array<MenuItem> = [];
    public loading: boolean = false;
    private body: HTMLElement;

    public isMobileMenu: boolean;
    @ViewChild("navBar") private navBar: NavbarComponent;

    @ViewChild("mainPanel") mainPanel: ElementRef;

    @ViewChild("customerModal") customerModal: ModalDirective;

    constructor(
        private router: Router, 
        private renderer: Renderer2, 
        private storageManager: StorageManager) {
            this.onResize(null);
    }

    @HostListener("window:resize")
    public onResize(event: any): void {
        this.isMobileMenu = ScreenHelper.isTabletOrPhone();;
    }

    ngOnDestroy(): void {
        if (!this.body)
            return;

        this.body.classList.remove("nav-open");
    }

    ngOnInit() {
        this.body = document.getElementsByTagName('body')[0];
        let isWindows = navigator.platform.indexOf('Win') > -1;

        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            this.body.classList.add("perfect-scrollbar-on");
        } else {
            this.body.classList.add("perfect-scrollbar-off");
        }

        if (isWindows) {
            ps.initialize(this.mainPanel.nativeElement);
        }

        this.router.events.subscribe(val => {
            if (val instanceof NavigationStart) {
                this.loading = true;

                if (this.navBar && this.isMobileMenu && this.navBar.sidebarVisible)
                    this.navBar.sidebarToggle();
            }
            else if (val instanceof NavigationEnd)
                this.loading = false;
            else if (val instanceof GuardsCheckEnd && !val.shouldActivate) {
                this.loading = false;
            }

            if (!(val instanceof NavigationEnd)) {
                return;
            }

            this.mainPanel.nativeElement.scrollTop = 0;

            //TODO Resolver
        });
        this.storageManager.getCurrentUser().then(user => {
            const disabled = false;

            this.menuItems = [
                new MenuItem({
                    Name: "Main Dashboard",
                    Path: "/dashboard",
                    Collapsed: true,
                    Icon: 'dashboard',
                    Disabled: disabled,
                    IconClass: 'material-icons',
                    Children: [],
                    ShowCaret: false,
                })];

            this.menuItems.push(new MenuItem({
                Name: "Calculator",
                Path: "/calculator/agent",
                Icon: 'iso',
                Collapsed: true,
                IconClass: 'material-icons',
                Disabled: disabled,
                Children: [],
                ShowCaret: false
            }));
            this.menuItems.push(new MenuItem({
                Name: 'Customers',
                Path: '/management/customer',
                Icon: 'recent_actors',
                IconClass: 'material-icons',
                Children: [],
                ShowButton: true,
                ButtonText: "+",
                ButtonHandler: () => this.customerModal.show()
            }));
            this.menuItems.push(
                new MenuItem({
                    Name: 'Management',
                    Path: '',
                    Icon: 'folder_shared',
                    Collapsed: true,
                    IconClass: 'material-icons',
                    Disabled: disabled,
                    Children: [
                        // by task https://jira.ak-tech.com/browse/BB-3054
                        // new MenuItem({
                        //     Name: 'Agents',
                        //     Path: '/management/agent',
                        //     Icon: 'perm_contact_calendar',
                        //     IconClass: 'material-icons',
                        //     Children: []
                        // }),
                        new MenuItem({
                            Name: 'Orders',
                            Path: '/management/order',
                            Icon: 'receipt',
                            IconClass: 'material-icons',
                            Children: []
                        }),
                        new MenuItem({
                            Name: 'Products',
                            Path: '/management/product',
                            Icon: 'card_travel',
                            IconClass: 'material-icons',
                            Children: []
                        }),
                        new MenuItem({
                            Name: 'Locations',
                            Path: '/management/location',
                            Icon: 'pin_drop',
                            IconClass: 'material-icons',
                            Children: []
                        }),
                        new MenuItem({
                            Name: 'Amazon Sellers',
                            Path: '/management/amazon/sellers',
                            Icon: 'perm_contact_calendar',
                            IconClass: 'material-icons',
                            Children: []
                        }),
                        new MenuItem({
                            Name: 'Customers Import',
                            Path: '/management/customersImport',
                            Icon: 'note_add',
                            IconClass: 'material-icons',
                            Children: []
                        }),
                    ]
                })
            );

            this.menuItems.push(new MenuItem({
                Name: 'Reports',
                Path: '',
                Icon: 'assignment_late',
                Collapsed: true,
                IconClass: 'material-icons',
                Disabled: disabled,
                Children: [
                    new MenuItem({
                        Name: 'Brokerage fees',
                        Path: '/report/fee',
                        Icon: 'monetization_on',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new MenuItem({
                        Name: 'Quotes',
                        Path: '/report/quantity',
                        Icon: 'filter_9_plus',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new MenuItem({
                        Name: 'RNS Status',
                        Path: '/report/rns/status',
                        Icon: 'filter_9_plus',
                        IconClass: 'material-icons',
                        Children: []
                    })
                ]
            }));

            this.menuItems.push(new MenuItem({
                Name: 'Settings',
                Path: '',
                Collapsed: true,
                Icon: 'settings',
                IconClass: 'material-icons',
                ShowCaret: false,
                Disabled: true,
                Children: [
                    // new MenuItem({
                    //     Name: 'Rate Database',
                    //     Path: '/settings/rates',
                    //     Icon: 'build',
                    //     IconClass: 'material-icons',
                    //     Disabled: disabled,
                    //     Children: []
                    // }),
                    // new MenuItem({
                    //     Name: 'Team',
                    //     Path: '/settings/team',
                    //     Icon: 'people',
                    //     IconClass: 'material-icons',
                    //     Disabled: disabled,
                    //     Children: []
                    // })
                ]
            }));

            this.menuItems.push(new MenuItem({
                Name: 'Zonos',
                Path: '/zonos',
                Collapsed: true,
                Icon: 'request_quote',
                IconClass: 'material-icons',
                ShowCaret: false,
                Children: []
            }));

            this.menuItems = this.filterMenuItems(this.menuItems, user);
        });
    }

    @HostListener('window:popstate', ['$event'])
    public hideSelect2(): void {
        let select = $('select.select2');

        select.each(function() {
            $(this).select2('close')
        });
    }

    ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    }

    private filterMenuItems(items: MenuItem[], user: User): MenuItem[] {
        let superAdminGroup: Group = user.Groups.find(x => x.Name == 'Super Admin');

        if (superAdminGroup != null)
            return items;

        let clientAdmin: Group = user.Groups.find(x => x.Name == 'Client Admin');
        let userAdmin: Group = user.Groups.find(x => x.Name == 'User Admin');
        let managementMenuItem: MenuItem = items.find(x => x.Name == 'Management');


        if (clientAdmin && managementMenuItem) {
            let agentsMenuItem: MenuItem = managementMenuItem.Children.find(x => x.Name == 'Agents');

            if (agentsMenuItem && !userAdmin) {
                managementMenuItem.Children.splice(managementMenuItem.Children.indexOf(agentsMenuItem), 1);
            }

            return items;
        }

        if (managementMenuItem)
            managementMenuItem.Children = managementMenuItem.Children.filter(x => x.Name == 'Agents');

        return [managementMenuItem];
    }

}



// WEBPACK FOOTER //
// ./app/components/layout/layout.component.ts